// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import userEditIcon from "@/assets/icons/user-edit.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type UserEditIconProps = Omit<IconProps, "name">;

export function UserEditIcon(props: UserEditIconProps): React.ReactNode {
  return <Icon name={userEditIcon} {...props} />;
}
